<template>
    <div class="usuarios px-4">
        <div class="table-container">
            <b-table id="usuarios-temp" striped responsive :items="rows" :fields="headerFields">
                <template v-slot:cell(createDate)="{ item }"> {{createDate( item.createDate ) }} </template>
                <template v-slot:cell(status)="{ item }">
                    <div class="status" :class="getStatusClass(item.disabled)">
                        {{ getStatusLabel(item.disabled) }}
                    </div>
                </template>
                <template v-slot:cell(id)="{ item }">
                    <ButtonContainer>
                        <ButtonEditTable :id="item.id" :titleTooltip="'Editar Usuario'" @click="edit(item.id)"/>
                        <ButtonConfigTable :id="item.id" :titleTooltip="'Associar Perfil'" @click="editPerfil(item)"/>
                        <ButtonRemoveTable :id="item.id" :titleTooltip="'Deletar Usuario '" @click="deletar(item)"/>
                    </ButtonContainer>
                </template>
            </b-table>
        </div>

        <ModalFormUsuario @close="resetModalForm" @updated="$emit('refresh')" :usuarioId="usuarioIdEdition" v-if="usuarioIdEdition"/>
		<ModalDeletarUsuario @close="resetModalForm" :usuario="usuarioDeletion" @deleted="$emit('refresh')" v-if="usuarioDeletion"/>
		<ModalPerfisUsuario @close="resetModalForm" :usuario="usuarioPerfisEdition"  v-if="usuarioPerfisEdition" />
    </div>
</template>

<script>

let headerFields = [
    {key: 'cpf', label: "CPF", thClass: 'px-2', tdClass: 'px-2'},
    {key: 'name', label: 'Nome', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'email', label: 'E-mail', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'createDate', label: 'Data cadastro', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'status', label: 'Status', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'id', label: 'Ações', thClass: 'px-2', tdClass: 'px-2'},
]

let columnsKeys = [
    'cpf',
    'name',
    'email',
    'id',
    'createDate',
    'status',
]

import ModalFormUsuario from './ModalFormUsuario.vue'
import ModalDeletarUsuario from './ModalDeletarUsuario.vue'
import ModalPerfisUsuario from './ModalPerfisUsuario.vue'
import ButtonContainer from "@/components/commons/table/components/ButtonContainer.vue";
import ButtonEditTable from "@/components/commons/table/components/ButtonEditTable.vue";
import ButtonConfigTable from "@/components/commons/table/components/ButtonConfigTable.vue";
import ButtonRemoveTable from "@/components/commons/table/components/ButtonRemoveTable.vue";

export default {
    components:{
      ModalFormUsuario,
      ModalDeletarUsuario,
      ModalPerfisUsuario,
      ButtonContainer,
      ButtonEditTable,
      ButtonConfigTable,
      ButtonRemoveTable
    },
    props: {
		rows: Array
	},
    data() {
        return {
            headerFields: [
                ...headerFields.filter(head => columnsKeys.includes(head.key)),
            ],
			usuarioIdEdition: null,
			usuarioDeletion: null,
			usuarioPerfisEdition: null
        }
    },
    methods:{
        edit( id ) {
            this.usuarioIdEdition = id
            this.showModalForm = true
        },
        editPerfil( user ){
            this.usuarioPerfisEdition = user
        },
        deletar( user ) {
            this.usuarioDeletion = user
        },
        getStatusClass( disable ){
            if(!disable) return "active"
            
            return "inative"
        },
        getStatusLabel( disable ){
            if(!disable) return "Ativo"
            
            return "Inativo"
        },
		resetModalForm(){
			this.usuarioIdEdition = null
            this.usuarioPerfisEdition = null
            this.usuarioDeletion = null
		},
		createDate( createDate ){
			let date = new Date( createDate )

			return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
		}
    }
}
</script>